import LivePurchases from './Component/LivePurchases';
import RehearsalEndedNotice from "./Component/RehearsalEndedNotice";
import AdminLiveVisibilityBadge from "./Component/AdminLiveVisibilityBadge";
import LiveToolbarIcon from "./Component/LiveToolbarIcon";
import LiveStatusBadge from "../../../Component/UI/LiveStatusBadge";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api2 from "../../../Component/axios_Interceptor/api2";
import { Live } from "../../../Component/Interface/Live";
import url from "../../../Component/server";
import {
  RowView,
} from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import AdminPageHeader, { AdminActionButton } from "../../../Component/UI/AdminPageHeader";
import PagingControl from "../../../Component/UI/PagingControl";
import api from "../../../Component/axios_Interceptor/api";

const Livelist = ({ adminPermissions = [], adminLevel }: { adminPermissions?: string[]; adminLevel?: string }) => {
  const Navigate = useNavigate();

  const [cnt, setCnt] = useState(0);
  const [livelist, setLivelist] = useState<Live[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const get_live_list = async () => {
    try {
      const res = await api.get(url.Communication_url.get_live_list, {
        params: { currentPage: currentPage, perPage: 20, sort: "DESC" },
      });
      setLivelist(res.data.liveList || []);
      setCnt(res.data.total || 0);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  const [myCoin, setMyCoin] = useState<number | null>(null);

  useEffect(() => {
    get_live_list();
    const timer = window.setInterval(get_live_list, 10000);
    return () => window.clearInterval(timer);
  }, [currentPage]);

  useEffect(() => {
    api.get(url.Communication_url.stock_coin)
      .then(({ data }) => {
        if (data.coin != null && Number.isFinite(Number(data.coin))) {
          setMyCoin(Number(data.coin));
        }
      })
      .catch(() => {});
  }, []);

  // 요일 반환
  const Dow = (date: string) => {
    const idx = new Date(date).getDay();
    return ["일", "월", "화", "수", "목", "금", "토"][idx];
  };

  const go_livemake = () => Navigate("make");
  const canManageLive = adminPermissions.includes("live_manage");

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Layout_Admin menuname={"라이브 목록"}>
      <PageContent>
      <RehearsalEndedNotice />
      <AdminPageHeader
        title="라이브 목록"
        description="예정된 방송과 지난 방송을 관리합니다."
        actions={(myCoin !== null || canManageLive) && <>
          {myCoin !== null && <span style={{ fontSize: 14, color: "var(--admin-muted)" }}>보유 코인 <strong style={{ color: "var(--admin-theme-link, var(--admin-accent-deep))" }}>{myCoin.toLocaleString()} C</strong></span>}
          {canManageLive && <AdminActionButton $primary type="button" onClick={go_livemake}>라이브 만들기</AdminActionButton>}
        </>}
      />

      <TableViewport role="region" aria-label="라이브 목록 표" tabIndex={0}>
        <TableContent>
      <Table className="header">
        <div className="time">예약일시</div>
        <div className="title">라이브 제목</div>
        <div className="duration">라이브 시간</div>
        <div className="capacity">수용인원</div>
        <div className="status">라이브상태</div>
        <div className="actions"></div>
      </Table>

      {livelist.map((data, idx) => {
        const date = data.live_start.slice(0, 10).replaceAll("-", ".");
        const time = data.live_start.slice(11, 16);

        const liveStart = new Date(data.live_start);
        const liveFinish = new Date(data.live_finish);

        const timeDifference = liveFinish.getTime() - liveStart.getTime();
        const hour = timeDifference / (1000 * 60 * 60);
        const duration = hour >= 1 ? `${Number(hour.toFixed(2))}시간` : `${Number((timeDifference / 60000).toFixed(1))}분`;

        return (
          <Table
            className="pointer"
            key={idx}
            onClick={() => Navigate(`${data.seq}`)}
          >
            <div className="time">
              {date}({Dow(date)}) {time}
            </div>
            <div className="title">
              <div className="live-heading">
                <AdminLiveVisibilityBadge secretYn={data.secret_yn} />
                <span className="live-title">{data.live_title}</span>
              </div>
              <span className="mobile-meta">
                {date}({Dow(date)}) {time}<br />
                {duration} · {data.live_limit}명
                {adminLevel === 'master' && <ListOrderButton liveSeq={data.seq} history inPagePopup label={`${data.live_title} 주문내역`} />}
              </span>
            </div>
            <div className="duration">{duration}</div>
            <div className="capacity">{data.live_limit}명</div>
            <div className="status"><LiveStatusBadge status={data.live_status} /></div>
            <div className="actions" onClick={stopPropagation}>
              {adminLevel === 'master' && <ListOrderButton liveSeq={data.seq} history inPagePopup label={`${data.live_title} 주문내역`} />}
            </div>
          </Table>
        );
      })}

        </TableContent>
      </TableViewport>

      <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      </PageContent>
    </Layout_Admin>
  );
};

export default Livelist;

const PageContent = styled.div`
  @media (max-width: 640px) {
    margin-inline: -12px;
    > header::before { left: -12px; right: -12px; }
  }
`;
const TableViewport = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  &:focus-visible { outline: 2px solid var(--admin-theme-focus, var(--admin-accent)); outline-offset: 2px; }
`;
const TableContent = styled.div`
  min-width: 840px;
  @media (max-width: 640px) { min-width: 0; }
`;

const ListOrderButton = styled(LivePurchases)`
  && { display: inline-flex; align-items: center; gap: var(--space-1); min-height: var(--control-sm); height: var(--control-sm); padding: 0 var(--space-2); font-size: var(--text-caption); }
  @media (pointer: coarse) { && { min-height: var(--touch-target); height: var(--touch-target); } }
`;
const Table = styled(RowView)`
  display: grid;
  grid-template-columns: minmax(176px, 1.4fr) minmax(200px, 2.4fr) repeat(3, minmax(72px, .7fr)) calc(var(--control-sm) * 4 + var(--space-2));
  align-items: center;
  gap: var(--space-4);
  box-sizing: border-box;
  min-height: var(--space-16);
  padding: var(--space-4) var(--space-6);
  border-bottom: 1px solid var(--color-border-default);
  font-family: var(--font-family-base);
  font-size: var(--text-body);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-body);

  &.header {
    min-height: var(--control-lg);
    padding-block: var(--space-3);
    background: var(--color-bg-subtle);
    color: var(--color-text-secondary);
    font-size: var(--text-caption);
  }
  &.pointer:hover { background: var(--color-bg-subtle); }
  > div { min-width: 0; text-align: center; }
  > .time, > .title { text-align: left; }
  .time { font-variant-numeric: tabular-nums; white-space: nowrap; }
  .live-heading { display: flex; flex-wrap: wrap; align-items: center; gap: var(--space-2); }
  .live-title { display: block; min-width: 0; line-height: var(--leading-body-lg); overflow-wrap: anywhere; }
  .mobile-meta { display: none; }
  .actions { display: flex; flex-wrap: wrap; justify-content: flex-end; align-items: center; gap: var(--space-2); }
  .status > span {
    min-height: var(--control-sm);
    padding-inline: var(--space-3);
    font-family: var(--font-family-base);
    font-size: var(--text-caption);
  }

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: var(--space-4);
    padding: var(--space-5) var(--space-4);
    &.header { align-items: center; padding-block: var(--space-3); }
    .time, .duration, .capacity, .actions { display: none; }
    > .status { min-width: var(--space-16); }
    .live-title { word-break: keep-all; }
    .mobile-meta {
      display: block;
      margin-top: var(--space-3);
      color: var(--color-text-secondary);
      font-size: var(--text-caption);
      line-height: var(--leading-body-lg);
    }
  }
`;
